// Public CMS helper for Maler Carsten Janum ApS

export const CMS_BASE_URL = 'https://api.dev.auxo.dk/public';

export const GLOBAL_COMPANY_INFO = {
  company_name: 'Maler Carsten Janum ApS',
  phone: '+45 22 75 93 58',
  phone_raw: '22759358',
  email: 'maler@carstenjanum.dk',
  address: 'Godsbanen 25 4 3, 9000 Aalborg',
  cvr: '44 50 39 05',
  logo_url: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/logo-4.png'
};

export async function fetchCmsCollection(collectionName) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/v2/content/${collectionName}?limit=100`);
    if (!res.ok) return null;
    const data = await res.json();
    return data.items || [];
  } catch (err) {
    console.warn(`Could not fetch CMS collection ${collectionName}:`, err);
    return null;
  }
}

export function getResizedImageUrl(url, width = 800, quality = 85) {
  if (!url || typeof url !== 'string') return '';
  if (url.includes('assets.auxodev.dk') && !url.includes('/cdn-cgi/image/')) {
    return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`);
  }
  return url;
}
